const C = {
  name: "Eye",
  dimensions: { width: 40, height: 27 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4214)">
    <path d="M19.75 19.0029C16.44 19.0029 13.75 16.3129 13.75 13.0029C13.75 9.69293 16.44 7.00293 19.75 7.00293C23.06 7.00293 25.75 9.69293 25.75 13.0029C25.75 16.3129 23.06 19.0029 19.75 19.0029ZM19.75 5.00293C15.34 5.00293 11.75 8.59293 11.75 13.0029C11.75 17.4129 15.34 21.0029 19.75 21.0029C24.16 21.0029 27.75 17.4129 27.75 13.0029C27.75 8.59293 24.16 5.00293 19.75 5.00293Z" />
    <path d="M19.75 14.0029C19.2 14.0029 18.75 13.5529 18.75 13.0029C18.75 12.4529 19.2 12.0029 19.75 12.0029C20.3 12.0029 20.75 12.4529 20.75 13.0029C20.75 13.5529 20.3 14.0029 19.75 14.0029ZM19.75 10.0029C18.1 10.0029 16.75 11.3529 16.75 13.0029C16.75 14.6529 18.1 16.0029 19.75 16.0029C21.4 16.0029 22.75 14.6529 22.75 13.0029C22.75 11.3529 21.41 10.0029 19.75 10.0029Z" />
    <path d="M19.75 24.0029C11.23 24.0029 4.01 15.5829 2 13.0029C4.01 10.4229 11.23 2.00293 19.75 2.00293C28.27 2.00293 35.49 10.4129 37.5 13.0029C35.49 15.5929 28.27 24.0029 19.75 24.0029ZM39.08 11.7829C36.93 9.01293 29.19 0.00292969 19.75 0.00292969C10.32 0.00292969 2.57 9.01293 0.42 11.7829C-0.14 12.5029 -0.14 13.5129 0.42 14.2329C2.57 16.9929 10.32 26.0029 19.75 26.0029C29.18 26.0029 36.93 16.9929 39.08 14.2229C39.64 13.5029 39.64 12.5029 39.08 11.7829Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4214">
    <rect width="40" height="26" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>

  `
};
export {
  C as Eye
};
